import React, { Component } from 'react';
import './index.scss';
import dinpic1 from '../../../../assets/app/about/din2p/din2p-1.png'
import dinpic2 from '../../../../assets/app/about/din2p/din2p-2.png'
import dinpic3 from '../../../../assets/app/about/din2p/din2p-3.png'


class Din2p extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  
  componentDidMount(){
     
  }

  render() {
    return (
      <div className="imageBlock">
          <img src={dinpic1}/>
          <img src={dinpic2}/>
          <img src={dinpic3}/>
      </div>
    );
  }

}

export default Din2p;
